"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.walletId = void 0;
exports.walletId = "mdw";
